import {FC, useState} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../../auth'
import {offersAndroidApp} from '../core/androidApp'
import {
  isInstallOfferSnoozed,
  openInstallGuide,
  promptInstall,
  snoozeInstallOffer,
} from '../core/installPrompt'
import {
  installedAppIcon,
  installedAppName,
  installOfferLine,
  thisDevice,
  useInstallState,
} from '../core/useInstallState'
import '../installApp.scss'

/**
 * The dashboard's install offer, beside its other notices, while the panel is not installed on
 * this device. «بعداً» keeps it away for SNOOZE_DAYS here; «امکانات تازه» and the account menu
 * still open the guide. Never in a support session: the operator is on someone else's account.
 */
export const DashboardInstallNotice: FC = () => {
  const {currentUser} = useAuth()
  const {prompt, detected, guide, installed} = useInstallState()
  const [snoozed, setSnoozed] = useState(() => isInstallOfferSnoozed())

  if (installed || snoozed || currentUser?.support) return null

  // On an Android phone the guide comes first: it offers the Android app, then the web app.
  const androidApp = offersAndroidApp(detected)
  const install = async () => {
    if (androidApp || !prompt.canPrompt) {
      openInstallGuide()
      return
    }
    await promptInstall()
  }

  const later = () => {
    snoozeInstallOffer()
    setSnoozed(true)
  }

  return (
    <section className='mp-sso-notice mp-sso-notice--info ia-dash' aria-labelledby='ia-dash-title'>
      <img
        className='ia-dash__icon'
        src={toAbsoluteUrl(installedAppIcon())}
        alt=''
        width={40}
        height={40}
      />
      <div>
        <strong id='ia-dash-title'>
          {installedAppName()} را روی {thisDevice(detected)} نصب کنید
        </strong>
        <small>{installOfferLine(detected, guide)}</small>
      </div>
      <button type='button' className='mp-sso-notice__action ia-dash__action' onClick={install}>
        {androidApp ? 'دریافت برنامه' : prompt.canPrompt ? 'نصب' : 'راهنمای نصب'}
      </button>
      <button type='button' className='ia-dash__later' onClick={later} title='بعداً'>
        بعداً
      </button>
    </section>
  )
}
